import React, { useState } from "react";
import { TextField } from "@mui/material";
import { ArchiveOutlined, Inventory2Outlined } from "@mui/icons-material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ConfirmDialog from "./ConfirmDialog";
import { dayString } from "../utils/dates";

/**
 * "Delete" on the objects list does not delete anything — it moves the listing
 * into the archive with a term date, and the archive is where it can still be
 * read or returned. The old dialog said «Додати обєкт в архів?» over a pair of
 * «Ні»/«Так» buttons, which read as a delete confirmation to anyone who had
 * just clicked a bin icon. The wording and the amber tone here say what
 * actually happens.
 *
 * The payload is unchanged: AppRealtor's deleteItem() reads `displayDateFrom`.
 */
const BeforeDeleteObject = ({
  openDialog,
  id,
  deleteObject,
  handleCloseDialog,
}) => {
  const [displayDateFrom, setDisplayDateFrom] = useState(new Date());

  const confirm = function () {
    handleCloseDialog();
    // deleteItem() reads displayDateFrom; dateFrom is kept only so the payload
    // shape stays what it has always been.
    deleteObject(id, {
      displayDateFrom: displayDateFrom,
      dateFrom: dayString(displayDateFrom),
    });
  };

  const valid = displayDateFrom && !isNaN(new Date(displayDateFrom).getTime());

  return (
    <ConfirmDialog
      open={openDialog}
      onClose={handleCloseDialog}
      onConfirm={confirm}
      tone="warning"
      icon={<Inventory2Outlined />}
      title="Перенести об'єкт в архів?"
      description="Об'єкт зникне зі списку та з публічного сайту, але залишиться в архіві — звідти його можна повернути."
      confirmLabel="В архів"
      confirmIcon={<ArchiveOutlined />}
      confirmDisabled={!valid}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        {/* dd.MM.yyyy to match formatTableDate: this field used to print
            10 September as 09/10/2026 while every table printed it as
            10.09.2026, so the two disagreed about which number was the
            month. Only the display changes — deleteItem() still receives the
            Date object. */}
        <DatePicker
          value={displayDateFrom}
          onChange={function (newValue) {
            setDisplayDateFrom(newValue);
          }}
          inputFormat="dd.MM.yyyy"
          mask="__.__.____"
          renderInput={function (params) {
            return (
              <TextField
                {...params}
                inputProps={{
                  ...params.inputProps,
                  placeholder: "дд.мм.рррр",
                }}
                onKeyPress={function (e) {
                  if (e.key === "Enter") e.preventDefault();
                }}
                fullWidth
                variant="outlined"
                label="Термін архіву"
                helperText={
                  valid ? " " : "Вкажіть дату, до якої тримати об'єкт в архіві"
                }
                error={!valid}
              />
            );
          }}
        />
      </LocalizationProvider>
    </ConfirmDialog>
  );
};

export default BeforeDeleteObject;
